import { ASSET_PREFIX } from 'utils/constants';
import CategoryTrips from '../components/svg/CategoryTrips.svg';
import CategoryExperiences from '../components/svg/CategoryExperiences.svg';
import CategoryTech from '../components/svg/CategoryTech.svg';
import CategoryFamily from '../components/svg/CategoryFamily.svg';
import CategoryLifestyle from '../components/svg/CategoryLifestyle.svg';
import { ReactElement } from 'react';

export type MainPrizeCategoryProps = {
  name: string;
  icon: string;
  selectedIcon: string;
  href: string;
  order: number;
};

export const MAIN_PRIZE_CATEGORIES: Record<string, MainPrizeCategoryProps> = {
  all: {
    name: 'All Prizes',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/all-prizes.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/all-prizes-selected.svg`,
    href: '/prizes',
    order: 0,
  },
  trip: {
    name: 'Trips',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/trips.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/trips-selected.svg`,
    href: '/prizes/trip',
    order: 1,
  },
  experience: {
    name: 'Experiences',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/experience.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/experience-selected.svg`,
    href: '/prizes/experience',
    order: 2,
  },
  lifestyle: {
    name: 'Lifestyle',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/lifestyle.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/lifestyle-selected.svg`,
    href: '/prizes/lifestyle',
    order: 3,
  },
  tech: {
    name: 'Tech',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/tech.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/tech-selected.svg`,
    href: '/prizes/tech',
    order: 4,
  },
  family: {
    name: 'Family',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/family.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/family-selected.svg`,
    href: '/prizes/family',
    order: 5,
  },
};

export type MainPrizeCategory2026Props = {
  categoryCode: string;
  name: string;
  description: string;
  svg: ReactElement;
  href: string;
  examplePrizeImage: string;
};
export const MAIN_PRIZE_CATEGORIES_2026: Record<
  string,
  MainPrizeCategory2026Props
> = {
  trip: {
    categoryCode: 'trip',
    name: 'Trips & stays',
    description: 'Exciting holidays and escapes',
    svg: <CategoryTrips />,
    href: '/prizes/trip',
    examplePrizeImage: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/category/category-trips1.jpg`,
  },
  lifestyle: {
    categoryCode: 'lifestyle',
    name: 'Lifestyle',
    description: 'Home, beauty, hampers and more',
    svg: <CategoryLifestyle />,
    href: '/prizes/lifestyle',
    examplePrizeImage: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/category/category-lifestyle1.jpg`,
  },
  tech: {
    categoryCode: 'tech',
    name: 'Tech',
    description: 'The latest gadgets and gizmos',
    svg: <CategoryTech />,
    href: '/prizes/tech',
    examplePrizeImage: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/category/category-tech1.jpg`,
  },
  family: {
    categoryCode: 'family',
    name: 'Family',
    description: 'Amazing prizes for the whole family',
    svg: <CategoryFamily />,
    href: '/prizes/family',
    examplePrizeImage: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/category/category-family1.jpg`,
  },
  experience: {
    categoryCode: 'experience',
    name: 'Experiences',
    description: 'Brunch to bungee jumping',
    svg: <CategoryExperiences />,
    href: '/prizes/experience',
    examplePrizeImage: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/category/category-experiences1.jpg`,
  },
};
